"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var public_1 = require("./public");
// choice页面的特殊处理
var domaintype = utils_1["default"].getUrlParams('domaintype');
if (!domaintype)
    domaintype = '';
var choicedomain = domaintype == 'zp' ? "choicewzp1.eastmoney.com" : "choicejg.eastmoney.com";
// 通过链接的不同判断页面
var type = '';
var href = window.location.href;
if (href.indexOf('/soft/') > -1) {
    type = 'soft';
}
else if (href.indexOf('/choice/') > -1) {
    type = 'choice';
}
else {
    type = 'pc';
}
var host = window.location.origin;
var list = {
    // tabType: 0, // 0：为最新排行、年度排行、历届年度排行；1：为最新总排行、3个月排行、6个月排行、12个月排行
    // params: {
    //   st: 0,
    //   sr: '1',
    //   p: 1,
    //   ps: 50,
    //   name: '',
    //   type: 'list',
    //   industrycode: 'all',
    //   pageNo: '',
    //   pageNum: ''
    // },
    init: function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this, st, sortcol, months;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _this = this;
                        return [4 /*yield*/, public_1.hy_list()];
                    case 1:
                        _a.sent();
                        // 如果是soft和choice的页面，添加字段c
                        if (type != 'pc') {
                            // _this.params.c = 1;
                        }
                        st = utils_1["default"].getUrlParams('st') || displayYear;
                        // 如果链接中有参数，切换到对应的tab上，且table也要对应
                        $('#chart_type li').removeClass('at');
                        $("#chart_type li[year='" + st + "']").addClass('at');
                        sortcol = $('#chart_type li.at').attr('sort');
                        months = ['1', '3', '6', '12'];
                        if (months.indexOf(st) > -1) {
                            _this.loadTable("month", displayYear, sortcol);
                        }
                        else {
                            _this.loadTable("year", displayYear, sortcol);
                        }
                        // 切换tab
                        _this.changeTab();
                        // 历史年份的列
                        _this.allHistoryYear();
                        _this.search();
                        return [2 /*return*/];
                }
            });
        });
    },
    changeTab: function () {
        var _this = this;
        $('#chart_type li').on('click', function () {
            // 切换到‘历届年度排行’时显示‘查看历届年度排行’
            if ($(this).text() == '历届年度排行') {
                $('.prevAll').show();
                $('.prevAll .at').attr('year') == '2013' ? $('.cateday').hide() : $('.cateday').show();
            }
            else {
                $('.cateday').show();
                $('.prevAll').hide();
            }
            // 重新请求数据渲染
            var year = $(this).attr('year');
            var sortcol = $(this).attr('sort');
            var months = ['1', '3', '6', '12'];
            if (months.indexOf(year) > -1) {
                _this.loadTable("month", displayYear, sortcol);
            }
            else {
                _this.loadTable(year < '2014' ? "y2013" : "year", year, sortcol);
            }
            // 切换样式
            $('#chart_type li').removeClass('at');
            $(this).addClass('at');
        });
    },
    /**
 * 所有历史年，2013年及以前
 */
    allHistoryYear: function () {
        var _this = this;
        var html = '查看历届年度排行：';
        for (var year = displayYear - 2; year >= 2013; year--) {
            html += "<a year=\"" + year + "\" class=\"" + (year == displayYear - 2 ? 'at' : '') + "\" href=\"#\">" + year + "\u5E74</a>";
        }
        $('.prevAll').html(html);
        // 点击切换历届年份排行
        $('.prevAll a').on('click', function (e) {
            e.preventDefault();
            var year = $(this).attr('year');
            if (year <= 12) {
                year = displayYear;
            }
            $('.prevAll a').removeClass('at');
            $(this).addClass('at');
            $('#chart_type .at').attr({ 'year': year });
            var sortcol = "YEAR_YIELD";
            $('#chart_type .at').attr({ 'sort': sortcol });
            if (year < '2014') {
                // 2014年前的数据特殊处理，即2013年数据特殊处理
                $('.cateday').hide(); //2013不支持行业筛选
                _this.loadTable("y2013", year, sortcol);
            }
            else {
                $('.cateday').show();
                _this.loadTable("year", year, sortcol);
            }
        });
    },
    /**
 * list页面的搜索功能
 */
    search: function () {
        var _this = this;
        // 点击清空搜索,然后重新请求
        $('.resetBtn').on('click', function () {
            $('#txt_name').val('');
            $("#dataview_ph").emdataview().refresh();
        });
        // 点击按钮搜索
        $('.queryBtn').on('click', function () {
            goSearch();
        });
        // 输入框回车
        $('#txt_name').on('keydown', function (event) {
            if (event.keyCode === 13) {
                goSearch();
            }
        });
        function goSearch() {
            $("#dataview_ph").emdataview().options.pagenumber = 1;
            $("#dataview_ph").emdataview().refresh();
        }
    },
    changeSort: function () {
        var _this = this;
        $("#dataview_ph").off("click", ".th-inner").on("click", ".th-inner", function (e) {
            e.preventDefault();
            var $this_th = $(this).parent();
            var st = $this_th.data().sortname;
            if (!st || st == "YEAR_YIELD") {
                return;
            }
            $('#chart_type li').removeClass('at');
            $("#chart_type li[sort='" + st + "']").addClass('at');
            var sortcol = $('#chart_type li.at').attr('sort');
            _this.loadTable("month", displayYear, sortcol);
        });
    },
    loadTable: function (tabletype, year, sort) {
        var _this = this;
        var opt = {
            urlkeyvalues: {
                pagenumber: "pageNumber",
                pagesize: "pageSize",
                sortname: "sortColumns",
                sortorder: "sortTypes"
            },
            dataurl: {
                hostname: 'url',
                url: '/dataapi/invest/list',
                params: {
                    reportName: "RPT_ANALYST_INDEX_RANK",
                    columns: "ALL",
                    source: "WEB",
                    client: "WEB",
                    filter: "(YEAR=\"" + year + "\")",
                    distinct: "ANALYST_CODE",
                    limit: type == "pc" ? "top100" : "all"
                }
            },
            datatype: "json",
            tabletype: tabletype,
            sortname: sort,
            filteroptions: [
                {
                    name: 'filter',
                    fieldname: 'type',
                    filterselector: ".st_type_3",
                    filtersoptionselector: "li",
                    selectedclass: "at2",
                    values: function (value) {
                        return year == "2013" ? "" : "(INDUSTRY_CODE=\"" + value + "\")";
                    }
                }
            ],
            queryparams: function (options, queryparams) {
                var name = $("#txt_name").val();
                if (name) {
                    queryparams.data.filter += "(ANALYST_NAME like \"%" + name + "%\")";
                }
                if (year != "2013" && ($(".st_type_3 li.at2").data("value") != "")) {
                    queryparams.data.limit = "top10"; //行业排行只显示前十
                }
                return queryparams;
            },
            columns: {
                ANALYST_NAME: {
                    formatter: function (value, item, i, field) {
                        var pc = "<a href=\"" + item.ANALYST_CODE + ".html\">" + value + "</a>";
                        var soft = "<a target=\"_self\" href=\"javascript:void(0);\" onfocus=\"this.blur();\" onclick=\"external.OnClickEvent(this.rel);\" rel=\"return(false &amp;&amp; [].push('#type=03&amp;title=" + value + "\u8BE6\u7EC6\u8D44\u6599&amp;size=1024x650&amp;url=" + host + "/invest/invest/soft/detail.aspx?id=" + item.ANALYST_CODE + "'));\">" + value + "</a>";
                        var choice = "<a target=\"_blank\" href=\"/invest/invest/choice/detail.aspx?type=" + domaintype + "&id=" + item.ANALYST_CODE + "\">" + item.ANALYST_NAME + "</a>";
                        return type == 'soft' ? soft : (type == 'choice' ? choice : pc);
                    }
                },
                ORG_NAME: emfield.string,
                INDEX_VALUE: {
                    formatter: { num: 2, omit: false }
                },
                detail: {
                    formatter: function (value, item, i, field) {
                        var pc = "<a href=\"" + item.ANALYST_CODE + ".html\">\u67E5\u770B\u8BE5\u5206\u6790\u5E08\u6307\u6570</a>";
                        var soft = "<a target=\"_self\" href=\"javascript:void(0);\" onfocus=\"this.blur();\" onclick=\"external.OnClickEvent(this.rel);\" rel=\"return(false &amp;&amp; [].push('#type=03&amp;title=" + item.ANALYST_NAME + "\u8BE6\u7EC6\u8D44\u6599&amp;size=1024x650&amp;url=" + host + "/invest/invest/soft/detail.aspx?id=" + item.ANALYST_CODE + "'));\">\u67E5\u770B\u8BE5\u5206\u6790\u5E08\u6307\u6570</a>";
                        var choice = "<a target=\"_blank\" href=\"/invest/invest/choice/detail.aspx?type=" + domaintype + "&id=" + item.ANALYST_CODE + "\">\u67E5\u770B\u8BE5\u5206\u6790\u5E08\u6307\u6570</a>";
                        return type == 'soft' ? soft : (type == 'choice' ? choice : pc);
                    }
                },
                YEAR_YIELD: emfield.bfb2,
                YIELD_3: emfield.bfb2,
                YIELD_6: emfield.bfb2,
                YIELD_12: emfield.bfb2,
                SECURITY_COUNT: emfield.string,
                NEWEST_STOCK_RATING: {
                    formatter: function (value, item, i, field) {
                        var code = value === null || value === void 0 ? void 0 : value.substring(0, 6);
                        var mktcode = (value === null || value === void 0 ? void 0 : value.length) > 6 ? utils_1["default"].getstockmarket(code) : '';
                        var pc = "<a href=\"" + item.ANALYST_CODE + ".html#new\">" + value.replace(" ", "&nbsp;") + "</a>";
                        var soft = "<a target=\"_self\" href=\"javascript:void(0);\" onfocus=\"this.blur();\" onclick=\"external.OnClickEvent(this.rel);\" rel=\"return(false &amp;&amp; [].push('#type=01&amp;&amp;code=" + mktcode + code + "'));\">" + value.replace(" ", "&nbsp;") + "</a>";
                        var choice = "<a target=\"_blank\" href=\"/invest/invest/choice/detail.aspx?type=" + domaintype + "&id=" + item.ANALYST_CODE + "\">" + value.replace(" ", "&nbsp;") + "</a>";
                        return type == 'soft' ? soft : (type == 'choice' ? choice : pc);
                    }
                }
            },
            onPostBody: function (data) {
                if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                    $('.list-time').text(utils_1["default"].dateFormat(data[0].TRADE_DATE));
                }
                // else{
                //     $('.no-records-found td').text('抱歉，没有在行业前10的分析师中找到结果');
                // }
                $("#dataview_ph .zs_type").html(year < displayYear ? "年度" : "最新");
                $("#dataview_ph .year_txt").html(year);
                var tip = "<span class=\"tip\" style=\"display: " + (year < displayYear && year > 2013 ? 'block' : 'none') + ";\">\n                    \u6CE8\uFF1A\u53C2\u4E0E<span class=\"list-year\">" + year + "</span>\u5E74\u6392\u884C\u7684\u5206\u6790\u5E08\u5728\u672C\u5E74\u5185\u8FDB\u884C\u8BC4\u7EA7\u7684\u80A1\u7968\u9700\u4E0D\u5C11\u4E8E5\u53EA\n                </span>";
                var html = "<div class=\"more_ad\">\n                        " + tip + "\n                    <span>\n                        <a class=\"red\" href=\"//choice.eastmoney.com/?adid=665\">\u66F4\u591A\u8DDF\u8E2A\u6210\u5206\u80A1\u8BF7\u70B9\u51FB\u4E0B\u8F7D\u4E1C\u65B9\u8D22\u5BCCChoice\u91D1\u878D\u7EC8\u7AEF&gt;&gt;</a>\n                    </span>\n                </div>";
                if ($("#dataview_ph").find(".tip").length == 0) {
                    $("#dataview_ph .dataview-center").after(type == "pc" ? html : tip);
                }
                if (type != "pc") {
                    $(".dataview-floatheader").hide();
                    $("#dataview_ph").emdataview().onScroll = function () {
                        return;
                    };
                }
                _this.changeSort(); //加排序事件
                pager.loadPager();
            }
        };
        $("#dataview_ph").emdataview(opt);
    }
};
var pager = {
    loadPager: function () {
        var _this = this;
        // 根据切换的tab类型，来判断具体取哪一个table的分页作为计量标准
        // var eq = list.tabType == 0 ? 0 : 1;
        var p = $('.tablepager').find('.pagerbox');
        var current = p.find('.active').attr('data-page');
        var total = p.find('a:nth-last-child(1)').text();
        if (!p || p.length == 0 || p.is(":hidden")) {
            current = 1;
            total = 1;
        }
        total = total == '下一页' ? p.find('a:nth-last-child(2)').text() : total;
        current = parseInt(current, 10);
        total = parseInt(total, 10);
        var html = "\n        <b>\u5F53\u524D\u7B2C<span class=\"red\">" + current + "</span>\u9875</b>\n        <b class=\"" + (current == '1' ? 'n1' : 'n2') + " index\">\u9996\u9875</b>\n        <b class=\"" + (current == '1' ? 'n1' : 'n2') + " prev\">\u4E0A\u4E00\u9875</b>\n        <b class=\"" + (total && total > current ? 'n2' : 'n1') + " next\">\u4E0B\u4E00\u9875</b>\n        <b class=\"" + (total && total > current ? 'n2' : 'n1') + " last\">\u5C3E\u9875</b>\n        <b>\u5171<span class=\"red\">" + (total ? total : 1) + "</span>\u9875</b>\n      ";
        $('#miniPageNav').html(html);
        // 绑定按钮的事件
        if (total != 1) {
            _this.evenPage(total);
        }
    },
    /**
     * 分页按钮的事件绑定
     * @param total 总条数
     */
    evenPage: function (total) {
        var _this = this;
        var cur_page = $("#dataview_ph").emdataview().options.pagenumber;
        $('.index').on('click', function () {
            _this.changePage(1);
        });
        $('.prev').on('click', function () {
            if (cur_page > 1) {
                _this.changePage(cur_page - 1);
            }
        });
        $('.next').on('click', function () {
            if (cur_page < total) {
                _this.changePage(cur_page + 1);
            }
        });
        $('.last').on('click', function () {
            _this.changePage(total);
        });
    },
    /**
     * 切换页
     * @param page 切换到的页面
     */
    changePage: function (page) {
        $("#dataview_ph").emdataview().options.pagenumber = page;
        $("#dataview_ph").emdataview().refresh();
    }
};
list.init();
